<!-- && isUS_Profile -->

<div class="row">
  <div class="col-md-12" *ngIf="hasRMI">
    <div class="promoCards">
      <div class="title-md text-center title-color-2">Request Medical Science Liaison</div>
      <span class="pt-1"> <img src="./assets/images/user.png"></span>
      <p> <strong class="text-clr pointer texthover" (click)="openContactModal(template)"> Click here </strong> to submit your request to be contacted by your local Medical Science Liaison. </p>
    </div>
  </div>

  <div class="col-md-12">
    <div class="promoCards">
      <div class="title-md text-center title-color-2">Report an Adverse Event</div>
      <span class="pt-1"> <img src="./assets/images/alert.png"></span>
      <p> <strong class="text-clr pointer texthover" (click)="navigateReportPopup('AE')"> Click here </strong> to report an Adverse Event or Side Effect.</p>
    </div>
  </div>

  <div class="col-md-12">
    <div class="promoCards">
      <div class="title-md text-center title-color-2">Report a Product Quality Complaint</div>
      <span class="pt-1"> <img src="./assets/images/alert.png"> </span>
      <p> <strong class="text-clr pointer texthover" (click)="navigateReportPopup('PC')"> Click here </strong> to report a Product Quality Complaint.</p>
    </div>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
    <h5 class="modal-title w-100 d-block">
      Contact Us
      <span class="mt-1 float-right fs-13" data-dismiss="modal" (click)="modalRef?.hide()">
        <i class="fas fa-times pointer"></i>
      </span>
    </h5>
  </div>
  <div class="modal-body px-0">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 col-md-12">
          <ul class="contactUs">
            <li>
              <div class="row">
                <div class="col-md-12" *ngIf="isUS_Profile">
                  <p>
                    <span class="text-center"><i class="fas fa-phone-alt"></i></span>
                    <small>1-800-844-2830</small>
                  </p>
                  <p>
                    <small>Regular Office Hours: Monday to Friday 8:00 am - 5:30 pm ET</small>
                  </p>
                </div>

                <div class="col-md-12" *ngIf="!isUS_Profile">
                  <span class="text-center"><i class="fas fa-phone-alt"></i></span>
                  <small> Please locate your country-specific contact number <strong style="color: #7a8aca; cursor: pointer;" (click)="openContactDoc('Non-US_Contact_Details.docx', 'Mallinckrodt Contact Details')"> here. </strong> </small>
                </div>
              </div>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-template>
